var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',{staticClass:"mb-3 px-5 pt-6 pb-6 rounded-xl card-container",attrs:{"elevation":0}},[_c('div',{staticClass:"total-video-views"},[_c('p',[_vm._v("Total video views")]),_c('span',[_vm._v(_vm._s(_vm.recordDetails.total_views))])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }